import React from 'react'

import ControlButtonStandard from "../../../../buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../buttons/control-button/@types"

type Props = {
    className?  : string

    onClick?    : callback
}

export default function AttachmentButtonRemove(props: Props) {


    const onClick = (e:any) => {
        e.stopPropagation()
        props.onClick?.(e)
    }

    return <ControlButtonStandard className = {props.className}
                                  size      = {ControlButtonSize.SIZE_28}
                                  iconClass = "i5-trash-alt red fs-12"
                                  onClick   = {onClick}/>
}
